/*
 * Nexo footer:
 * - While the footer is on screen, lift the floating WhatsApp button above it
 *   (html.nx-foot-in + --nx-foot-h), so the button never sits on top of the footer links.
 * - While the page fully covers it (html.nx-foot-off), the sticky wrapper is hidden but not its
 *   contents, and Safari is asked to look at the screen edges again, so the black strip it paints
 *   under its toolbar at the bottom of the page goes away when scrolling back up (nexo.css,
 *   "Footer reveal").
 * A 1px marker right where <main> ends tells when the footer starts to show; an
 * IntersectionObserver with the viewport as root also works inside Horizon's desktop
 * scroll container (.page-wrapper).
 */

const root = document.documentElement;
let poke;
let footerObserver;
let sizeObserver;

// Safari (iOS 26) re-checks the bars along the screen edges whenever a fixed element appears or
// goes away; scrolling alone doesn't make it look again
function refreshEdgeColors() {
  if (!poke?.isConnected) {
    poke = document.createElement('div');
    poke.className = 'nx-edge-poke';
    poke.setAttribute('aria-hidden', 'true');
    document.body.append(poke);
  }
  poke.classList.toggle('is-fixed');
}

function setup() {
  const stick = document.querySelector('.page-wrapper > .nx-foot-stick');
  const band = stick?.querySelector('.nx-foot');
  if (!stick || !band || !('IntersectionObserver' in window)) return;

  let marker = document.querySelector('.nx-foot-marker');
  if (!marker) {
    marker = document.createElement('div');
    marker.className = 'nx-foot-marker';
    marker.setAttribute('aria-hidden', 'true');
    stick.before(marker);
  }

  const setHeight = () => root.style.setProperty('--nx-foot-h', `${band.offsetHeight}px`);
  setHeight();
  sizeObserver?.disconnect();
  if ('ResizeObserver' in window) {
    sizeObserver = new ResizeObserver(setHeight);
    sizeObserver.observe(band);
  }

  footerObserver?.disconnect();
  footerObserver = new IntersectionObserver(([entry]) => {
    const shown = entry.isIntersecting || entry.boundingClientRect.top < 0;
    const wasOff = root.classList.contains('nx-foot-off');
    root.classList.toggle('nx-foot-in', shown);
    root.classList.toggle('nx-foot-off', !shown);
    if (wasOff === shown) refreshEdgeColors();
  });
  footerObserver.observe(marker);
}

if (!window.nexoFooterReady) {
  window.nexoFooterReady = true;
  setup();
  // Theme editor: the section is re-rendered when its settings change
  document.addEventListener('shopify:section:load', setup);
}
